<template>
    <component
        :is="tag"
        class="form-row">
        <!-- @slot Слот по-умолчанию -->
        <slot></slot>
    </component>
</template>

<script>
/**
 * `<SbsFormRow>` - это контейнер для компоновки форм, не имеет полей
 */
export default {
    name: 'SbsFormRow',
    props: {
        /**
         * Определяет тег HTML для контейнера
         */
        tag: {
            type: String,
            default: 'div',
        },
    },
};
</script>

<style lang="scss">
    .form-row {
        display: flex;
        flex-wrap: wrap;
        margin-right: -5px;
        margin-left: -5px;
    }

    .form-row > .col,
    .form-row > [class*="col-"] {
        padding-right: 5px;
        padding-left: 5px;
    }
</style>
